import { render, staticRenderFns } from "./uploadWater.vue?vue&type=template&id=5812e901&scoped=true"
import script from "./uploadWater.vue?vue&type=script&lang=js"
export * from "./uploadWater.vue?vue&type=script&lang=js"
import style0 from "./uploadWater.vue?vue&type=style&index=0&id=5812e901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5812e901",
  null
  
)

export default component.exports